import { cn, getAvatarColor, getAvatarPublicUrl, getInitials } from "@/lib/utils"

interface UserAvatarProps {
  name: string
  /** Path do bucket user-avatars OU URL completa. Null se sem foto. */
  avatarUrl?: string | null
  size?: "xs" | "sm" | "md" | "lg"
  className?: string
  title?: string
}

const SIZE_CLASSES = {
  xs: "w-6 h-6 text-[10px]",
  sm: "w-7 h-7 md:w-8 md:h-8 text-xs md:text-sm",
  md: "w-9 h-9 text-sm",
  lg: "w-12 h-12 text-base",
} as const

export function UserAvatar({ name, avatarUrl, size = "sm", className, title }: UserAvatarProps) {
  const dim = SIZE_CLASSES[size]
  const publicUrl = getAvatarPublicUrl(avatarUrl)

  if (publicUrl) {
    return (
      <img
        src={publicUrl}
        alt={name}
        title={title ?? name}
        className={cn("rounded-full object-cover shrink-0", dim, className)}
      />
    )
  }

  return (
    <span
      title={title ?? name}
      style={{ backgroundColor: getAvatarColor(name) }}
      className={cn(
        "rounded-full text-white font-bold flex items-center justify-center shrink-0",
        dim,
        className
      )}
    >
      {getInitials(name)}
    </span>
  )
}
